import IcInstagram from './IcInstagram'
export default IcInstagram
